import { render, staticRenderFns } from "./gantt-pagination.vue?vue&type=template&id=8376843c&scoped=true&"
import script from "./gantt-pagination.component.ts?vue&type=script&lang=ts&"
export * from "./gantt-pagination.component.ts?vue&type=script&lang=ts&"
import style0 from "./gantt-pagination.scss?vue&type=style&index=0&id=8376843c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8376843c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8376843c')) {
      api.createRecord('8376843c', component.options)
    } else {
      api.reload('8376843c', component.options)
    }
    module.hot.accept("./gantt-pagination.vue?vue&type=template&id=8376843c&scoped=true&", function () {
      api.rerender('8376843c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery-pricerite/components/gantt-pagination/gantt-pagination.vue"
export default component.exports